export default __webpack_public_path__ + "static/slider1-res-3bf72ea60b18c91d79e31dcbe9cfd280.jpg";